import $ from "jquery";
import Popper from "popper.js";

export default () => {
  const openCart = $(".Header-toggleCart");

  openCart.on("click", () => {
    $(".MiniCart").addClass("active");
    $("body").addClass("noScroll");
  });
  $(document).on("click", ".MiniCart-title button", () => {
    $(".MiniCart").removeClass("active");
    $("body").removeClass("noScroll");
  });

  const navButtonOpen = $(".Header-burger");
  const navButtonClose = $(".MenuCategory-close");
  const nav = $(".MenuCategory");
  const dropdownOpen = $(".display-dropdown");
  const dropdownClose = $(".MenuCategory-item-dropdown-back");

  dropdownOpen.on("click", function(e) {
    e.preventDefault();
    $(this)
      .parents(".MenuCategory-item")
      .find(".MenuCategory-item-dropdown")
      .addClass("active");
    nav.scrollTop(0);
    nav.addClass("noScroll");
  });

  dropdownClose.on("click", function(e) {
    e.preventDefault();
    $(this)
      .parents(".MenuCategory-item")
      .find(".MenuCategory-item-dropdown")
      .removeClass("active");

    nav.removeClass("noScroll");
  });

  navButtonOpen.on("click", () => {
    nav.addClass("active");
    $("body").addClass("noScroll");
  });

  navButtonClose.on("click", () => {
    nav.removeClass("active");
    $("body").removeClass("noScroll");
  });

  const popperContainer = document.querySelector(".layout-left");

  $(".MenuCategory-item").each((idx, el) => {
    el.addEventListener("mouseenter", () => {
      if ($(window).width() <= 1024) return;

      const popperContent = el.querySelector(
        ".MenuCategory-item-dropdown-content"
      );
      if (!popperContent) return;

      const popper = new Popper(el, popperContent, {
        placement: "bottom",
        modifiers: {
          preventOverflow: {
            boundariesElement: popperContainer || document.querySelector("body")
          }
        }
      });
    });
  });
};



// WEBPACK FOOTER //
// ./assets/src/js/modules/Nav.js